import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import isObject from '@userzoomlibraries/toolkit-js-utils/is-object';
import { T as ThemeManager } from './chunks/index.logic.js';
import { jsx } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import './chunks/index.logic2.js';
import '@userzoomlibraries/toolkit-js-utils/noop';
import './combine-themes.js';
import '@userzoomlibraries/toolkit-js-utils/is-empty-object';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var withTheme = function withTheme() {
  var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (isObject(parameter)) {
    var _parameter$base = parameter.base,
        base = _parameter$base === void 0 ? '' : _parameter$base,
        _parameter$styles = parameter.styles,
        styles = _parameter$styles === void 0 ? {} : _parameter$styles,
        _parameter$icons = parameter.icons,
        icons = _parameter$icons === void 0 ? {} : _parameter$icons,
        _parameter$inheritSty = parameter.inheritStyles,
        inheritStyles = _parameter$inheritSty === void 0 ? true : _parameter$inheritSty,
        _parameter$stylesTarg = parameter.stylesTarget,
        stylesTarget = _parameter$stylesTarg === void 0 ? document.head : _parameter$stylesTarg,
        _parameter$overridePr = parameter.overrideProps,
        overrideProps = _parameter$overridePr === void 0 ? {} : _parameter$overridePr,
        _parameter$breakpoint = parameter.breakpoints,
        breakpoints = _parameter$breakpoint === void 0 ? {} : _parameter$breakpoint;
    return function (WrappedComponent) {
      return function (props) {
        return /*#__PURE__*/jsx(ThemeManager, {
          breakpoints: breakpoints,
          base: base,
          styles: styles,
          icons: icons,
          inheritStyles: inheritStyles,
          stylesTarget: stylesTarget,
          children: /*#__PURE__*/jsx(WrappedComponent, _objectSpread(_objectSpread({}, overrideProps), props))
        });
      };
    };
  }

  throw new TypeError('Invalid type, Object type expected.');
};

withTheme.HOC_ID = 'Gearz.ThemeManager.withTheme';
withTheme.returnType = PropTypes.elementWithDescription('New component with a theme integrated.');
withTheme.parameterTypes = {
  parameter: PropTypes.shapeWithDescription({
    base: PropTypes.oneOfTypeWithDescription([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)) // needed for css method of styled-components
    ], 'styled-component CSS object with the base styles.'),
    styles: PropTypes.arrayOfWithDescription(PropTypes.object, 'Object with key/value with the styles by component id.'),
    icons: PropTypes.arrayOfWithDescription(PropTypes.object, 'Object with key/value with the icons by their names.'),
    breakpoints: PropTypes.shapeWithDescription({
      NAME_OF_BREAKPOINT: PropTypes.shapeWithDescription({
        suffix: PropTypes.stringWithDescription('String used to identify the breakpoint. It will be used to generate the props by breakpoint.'),
        columns: PropTypes.numberWithDescription('Number of columns to be configured in the grid.'),
        rowGap: PropTypes.numberWithDescription('Separation (in pixels) of each row of the grid.'),
        columnGap: PropTypes.numberWithDescription('Separation (in pixels) of each column of the grid.'),
        dimensions: PropTypes.shapeWithDescription({
          from: PropTypes.number,
          to: PropTypes.number
        }, 'Object with from (minWidth) and to (maxWidth) dimensions (in pixels) of the breakpoint.')
      }, 'Breakpoint')
    }, 'Breakpoints defined by the theme.'),
    stylesTarget: PropTypes.oneOfTypeWithDescription([PropTypes.instanceOf(HTMLElement), PropTypes.instanceOf(ShadowRoot)], 'Element where the styles will be injected. By default, styles will be injected in `document.head`.'),
    inheritStyles: PropTypes.boolWithDescription('Flag to force the inherit the parent styles in nested ThemeManagers.'),
    overrideProps: PropTypes.objectWithDescription('Additional props to pass to the overridden component.')
  }, 'Object with base, styles, icons and overrideProps to create the theme. Additionally, inheritStyles to be able to inherit the styles from the parent theme manager.')
};
withTheme.defaultParameters = {
  parameter: {
    base: '',
    styles: {},
    icons: {},
    inheritStyles: true,
    stylesTarget: document.head,
    overrideProps: {},
    breakpoints: {}
  }
};

export { withTheme as default };
